import type { WorkspaceId } from "../utils/workspaceStorage";

/** Single unified app workspace — query cache and API scope. */
export const APP_WORKSPACE: WorkspaceId = "event-os";
